import { HeaderSearchLink } from 'search/components/HeaderSearchLink/HeaderSearchLink'

import iconStyles from '../UserTools/Icons.module.scss'

export function Search() {
	return (
		<HeaderSearchLink
			iconClassName={iconStyles.icon}
			labelClassName={iconStyles.text}
			className={iconStyles.link}
		/>
	)
}
